module.exports = __webpack_public_path__ + "media/orderWin.5f212a12.mp3";